import {
  useAddressValidationValue,
  useCartShippingAddress
} from '@ecomm/data-cart'

import { getFirstSuggestedAddress } from '../SubmitButton/addressValidationHelpers'

export function AddressValidationModalPicker() {
  const addressValidation = useAddressValidationValue()
  const validatedAddress = getFirstSuggestedAddress(addressValidation)
  const shippingAddress = useCartShippingAddress()

  return (
    <div className="w-full">
      <p className="mb-2 mt-0 text-base font-bold md:mt-4 lg:text-lg">
        Verified address:
      </p>
      <div className="min-h-36 border-btn-primary flex w-full flex-col rounded-lg border-4 border-solid px-3 py-4 md:w-80 lg:w-96">
        <span className="mb-1 text-base font-medium md:font-bold lg:text-lg">
          {shippingAddress?.firstName} {shippingAddress?.lastName}
        </span>
        <span className="text-neutral-black text-base font-medium md:font-bold lg:text-lg">
          {validatedAddress.street}
        </span>
        {validatedAddress.additionalStreetInfo ? (
          <span className="text-neutral-black text-base font-medium md:font-bold lg:text-lg">
            {validatedAddress.additionalStreetInfo}
          </span>
        ) : null}
        <span className="text-neutral-black text-base font-medium md:font-bold lg:text-lg">
          {validatedAddress.city}, {validatedAddress.state}{' '}
          {validatedAddress.zipcode}
          {validatedAddress.plus4Code ? `-${validatedAddress.plus4Code}` : ''}
        </span>
      </div>
    </div>
  )
}
